import { useCustomMutation } from "@refinedev/core";
import { notification } from "antd";
import { SUBMIT_PROCUREMENT_PLAN, SubmitResponse, ConflictInfo } from "../queries";

interface UseSubmitProcurementPlanProps {
  onSuccess?: (data: SubmitResponse) => void;
  onConflict?: (conflictInfo: ConflictInfo) => void;
  onError?: (error: any) => void;
}

export const useSubmitProcurementPlan = ({
  onSuccess,
  onConflict,
  onError
}: UseSubmitProcurementPlanProps = {}) => {
  const { mutate: submitProcurementPlan, isLoading } = useCustomMutation<SubmitResponse>();

  const submit = async (input: { planId?: string; planData?: any }) => {
    try {
      submitProcurementPlan({
        meta: {
          gqlMutation: SUBMIT_PROCUREMENT_PLAN,
        },
        values: { input },
        url: "",
        method: "post"
      }, {
        onSuccess: (data) => {
          // Handle Refine's response structure - the actual data is nested
          const response = (data as any)?.data?.submitProcurementPlan || data;

          if (response.conflict?.hasConflict) {
            // Handle conflict scenario
            onConflict?.(response.conflict);
          } else {
            // Successfully submitted
            notification.success({
              message: 'Plan Submitted Successfully',
              description: 'The procurement plan has been submitted for approval.',
            });
            onSuccess?.(response);
          }
        },
        onError: (error) => {
          notification.error({
            message: 'Submission Failed',
            description: error.message || 'Failed to submit the procurement plan.',
          });
          onError?.(error);
        }
      });
    } catch (error) {
      console.error('Error submitting procurement plan:', error);
      onError?.(error);
    }
  };

  return {
    submit,
    isLoading
  };
};